import * as React from 'react';

import { Button, Message } from 'semantic-ui-react';
import Course from '../../../modules/lessons/domain/aggregates/course/Course';
import EntityId from '../../../../foundation/domain/EntityId';
import Exercise from '../../../modules/lessons/domain/aggregates/exercise/Exercise';
import ExerciseApi from '../../../modules/lessons/api/ExerciseApi';
import Registry from '../../../global/Registry';
import {Link} from 'react-router-dom';

interface Props {
	courseId?: EntityId<Course>;
}

interface State {
	exercises: Exercise[];
}

export default class ReviewReminder extends React.Component<Props, State> {

	public constructor () {
		super();

		this.state = { exercises: [] };
	}

	componentWillMount () {
		ExerciseApi.getInstance().getAllToRepeatByUserId(Registry.getInstance().me.getId()).then(exercises => this.setState({exercises}));
	}

	render () {
		const { courseId } = this.props;
		const { exercises } = this.state;

		if (exercises.length === 0) {
			return null;
		}

		return (
			<Message color={'orange'} style={{textAlign: 'center'}}>You have <strong>{exercises.length}</strong> {exercises.length === 1 ? 'exercise' : 'exercises'} to review. <Link to={'/exercises/review' + (courseId !== undefined ? '/' + courseId.getValue() : '')}><Button color={'orange'} floated={'right'}>Review exercises</Button></Link></Message>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/lesson/ReviewReminder.tsx